(function(angular) {
    'use strict';

    angular.module('wtApp.wtTracking', [
        'wtApp.wtTracking.tracking',
        'wtApp.wtTracking.errorHandler'
    ]);
})(window.angular);
